const people = [
    {
        name: 'Justine Ghiat',
        formation: 'Ostéopathe D.O',
        title: 'Gestionnaire du centre',
        diploma: 'Diplômée de l\'ULB',
        description: 'Prise en charge des lumbagos, torticolis, sciatiques, douleurs musculaires, migraines, vertiges, dysfonctions de la mâchoire, problèmes digestifs. Pour en savoir plus, visitez <a href="https://www.osteopatheghiat.be">mon site web.</a>',
        specialisation: 'Spécialisation en pré/post partum et pédiatrie',
        lang: null,
        appointment: 'Rendez-vous au 02/731.99.89 ou en ligne',
        website: 'https://www.doctoranytime.be/d/osteopathe/justine-ghiat',
        textButton: 'Prendre rendez-vous',
        picture: 'justineghiat.jpg',
        figcaption: null,
    },
    {
        name: 'Matteo Convent',
        formation: 'Ostéopathe D.O',
        title: null,
        diploma: 'Diplômé de l\'ULB',
        description: 'Je reçois en consultation les adolescents, les adultes et les seniors.',
        specialisation: 'Diplômé en ostéopathie et en kinésithérapie à l’Université Libre de Bruxelles, je propose une prise en charge ostéopathique personnalisée centrée sur la personne et son mouvement. Chaque traitement est adapté au patient, à son corps et à ses besoins spécifiques, qu’il s’agisse de douleurs articulaires, musculaires ou de tensions liées aux postures et aux gestes du quotidien. Mon objectif est de restaurer la mobilité, d’accompagner le corps dans son équilibre naturel et de favoriser un bien-être durable.',
        lang: null,
        appointment: 'Pour un rendez-vous, veuillez contacter le 0499/20.97.71 ou via le bouton ci-dessous',
        website: 'https://www.doctoranytime.be/d/osteopathe/matteo-convent',
        textButton: 'Prendre rendez-vous',
        picture: 'matteoconvent.jpeg',
        figcaption: null,
    },
    {
        name: 'Shahin Albeheshti',
        formation: 'Kinésithérapeute',
        title: null,
        diploma: 'Diplômé de l\'ULB',
        description: 'kinésithérapeute conventionné',
        specialisation: 'Prise en charge des pathologies de type orthopédiques/traumatiques ( lombalgies, arthroses,…), sportives (tendinopathies, lésion musculaires,…) ou neurologiques ( AVC, lésion médullaires,…)',
        lang: 'Langue parlée: français.',
        appointment: 'Pour un rendez-vous ou plus d’informations: 0488408043',
        website: 'https://www.doctoranytime.be/d/kinesitherapeute/shahin-albeheshti',
        textButton: 'Prendre rendez-vous',
        picture: 'shahinalbeheshti.jpeg',
        figcaption: null,
    },
    {
        name: 'Jessica Mouradyan',
        formation: 'Kinésithérapeute',
        title: null,
        diploma: null,
        description: 'Diplômée d’un master en kinésithérapie, je vous propose une prise en charge adaptée au patient.',
        specialisation: 'Je prends en charge des pathologies touchant les adultes ou personnes âgées que ce soit dans le musculo-squelettique (lombalgie, arthrose, cervicalgie, etc.), des pathologies neurologiques (AVC/Parkinson). Je prends également en charge les enfants pour des cas de scolioses.',
        lang: null,
        appointment: 'Rendez-vous par téléphone au 0489/88.46.64 ou en ligne. Pour les séances à domicile veuillez me téléphoner.',
        website: 'https://www.doctoranytime.be/d/kinesitherapeute/jessica-mouradyan',
        textButton: 'Prendre rendez-vous',
        picture: 'jessicamouradyan.jpeg',
        figcaption: null,
    },
    {
        name: 'Aurélie Vital',
        formation: 'Psychologue clinicienne',
        title: null,
        diploma: null,
        description: 'Psychologie intégrative. Consultations pour <b>enfants, adolescents et adultes</b>.',
        specialisation: 'Troubles anxieux, dépression, burn-out, difficultés professionnelles ou scolaires, harcèlement, questions existentielles, difficultés émotionnelles et relationnelles.',
        lang: null,
        appointment: 'Pour un rendez-vous ou plus d’informations: 0456.10.14.10. Le vendredi de 9h à 19h',
        website: 'https://www.doctoranytime.be/d/psychologue/aurelie-vital',
        textButton: 'Prendre rendez-vous',
        picture: 'aurelievital.jpg',
        figcaption: null,
    },
    {
        name: 'Lola Chatelain',
        formation: 'Psychologue et psychothérapeute systémicienne',
        title: null,
        diploma: 'Master psychologie du développement :  UCL - spécialisation thérapie familiale et systémique : Centre d’études de la famille et des systèmes',
        description: 'Consultations Enfants - Adolescent·es - Adultes - Couples - Familles',
        specialisation: 'Difficultés personnelles ou relationnelles, tensions familiales ou parentales , difficultés de gestion des émotions, périodes de transition de vie ou schémas répétitifs difficiles, troubles anxieux ou dépressifs, addictions, violences conjugales et des dynamiques de domination',
        lang: null,
        appointment: 'Rendez-vous le mercredi de 8h à 14h par mail <br/>à lola.chatelain.psy@gmail.com, via le bouton ci-dessous ou au 0484.16.30.40. <br/>Tarifs: Séance individuelle : 65€, séance couple ou famille : 85€. <br/>Annulation minimum 48h à l’avance, sinon la séance est due.',
        website: 'https://www.doctoranytime.be/d/psychologue/lola-chatelain?crm-widget=book-appointment',
        textButton: 'Prendre rendez-vous',
        picture: 'lolachatelain.jpg',
        figcaption: null,
    },
    {
        name: 'Emmanuel Wallon',
        formation: 'Hypnologue ',
        title: null,
        diploma: null,
        description: null,
        specialisation: "Relaxation, stress, angoisses, hyper-sensibilité, addictions, stress,… Je vous accompagne grâce à l’hypnose et des techniques de respiration.",
        lang: null,
        appointment: 'Rendez-vous ou renseignement +32 497 80 59 94 ou emmanuelwallon@gmail.com',
        website: null,
        textButton: null,
        picture: 'emmanuelwallon.jpeg',
        figcaption: null,
    },
    {
        name: 'Céline Cuvers',
        formation: 'Cours de Technique Alexander',
        title: null,
        diploma: 'Certifiée par l’aefmat en 2023',
        description: 'Je donne cours de Technique Alexander - méthode somatique qui aide les patient.es souffrant de douleurs chroniques à prendre conscience des tensions musculaires et des posturesnéfastes, et à les éviter - Un travail profond, en pleine conscience, qui améliore la coordination, l’équilibre, affine la proprioception et donneles moyens nécessaires à un meilleur usage de soi-même.',
        specialisation: 'Prise en charge de maux chroniques, douleurs cervicales, raideurs articulaires, problèmes digestifs, difficultés respiratoires ou vocales, migraines, microtraumatismes',
        lang: null,
        appointment: 'Cours individuel, de 45’, sur rendez-vous, les mardis matins entre 9h et 13h au 0474/604.995 ou par mail celinecurvers@hotmail.com',
        website: null,
        textButton: null,
        picture: 'celinecuvers.jpeg',
        figcaption: null,
    },
    {
        name: 'Et si c\'était vous?',
        formation: 'Notre équipe est entrain de s\'agrandir !',
        title: null,
        diploma: null,
        description: 'Si tu recherches un cabinet et que tu veux rejoindre notre équipe <br/> n’hésite pas à envoyer ta candidature à jghiat@gmail.com <br/>ou via le bouton ci-dessous.',
        specialisation: null,
        lang: null,
        appointment: null,
        website: 'mailto:jghiat@gmail.com',
        textButton: 'Postuler',
        picture: 'new.jpg',
        figcaption: 'Photo by Clay Banks on Unsplash',
    }
]

export default people;